import React from "react";
import { Navigate } from "react-router-dom";

const isTokenValid = (token) => {
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
};

const ProtectedAdminRoute = ({ children }) => {
  const token = localStorage.getItem("adminToken");

  if (!isTokenValid(token)) {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminInfo");
    return <Navigate to="/admin" replace />;
  }

  return children;
};

export default ProtectedAdminRoute;
